import { Component } from '@angular/core';
import { InAppPurchase } from '@ionic-native/in-app-purchase';
import { AlertController, App, LoadingController, NavController, Platform } from 'ionic-angular';
import { Api } from '../../providers/api';
import { BookmarkService } from '../../providers/bookmark-service';
import { BookmarksPage } from '../bookmarks/bookmarks';
import { BrowseDirectoryPage } from '../browse-directory/browse-directory';
import { ContactUsPage } from '../contact-us/contact-us';
import { MyAccountPage } from '../my-account/my-account';
import { SearchDirectoryPage } from '../search-directory/search-directory';
import { SubscriptionsPage } from '../subscriptions/subscriptions';
import { SubscriptionService } from '../../providers/subscription-service';
import { Subscription } from '../../models/subscription';
import { Subscription as RxjsSubscription } from 'rxjs';
import { HardcopyIntroPage } from '../purchase-hardcopy/pages/intro/intro';
import { UserService } from '../../providers/user-service';
import { User } from '../../models/user';
import { LoginPage } from '../login/login';
import { DirectoryService } from '../../providers/directory-service';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';
import { GetHardcopyPurchaseUrlResponse } from "../../providers/api/responses/GetHardcopyPurchaseUrlResponse";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { DesktopService } from "../../providers/desktop-service";
import { ContactPage } from "../desktop/contact/contact";
import { BlankDesktopPage } from "../desktop/blank/blank";

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

    public isDesktop: boolean = false;

    public subscription: Subscription = null;
    public subscriptionWatcher: RxjsSubscription;

    public user: User = null;
    public userWatcher: RxjsSubscription;

    constructor(
        public alertCtrl: AlertController,
        public analytics: FirebaseAnalytics,
        public api: Api,
        public bookmarks: BookmarkService,
        public directory: DirectoryService,
        public inAppPurchase: InAppPurchase,
        public loadingCtrl: LoadingController,
        public navCtrl: NavController,
        public platform: Platform,
        public subscriptionService: SubscriptionService,
        public userService: UserService,
        private appCtrl: App,
        public desktop: DesktopService,
        public iab: InAppBrowser,
        private desktopService: DesktopService,
    ) {

    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('Home');
    }

    public ngAfterViewInit() {
        this.isDesktop = this.desktop.isDesktop();

        this.subscription = this.subscriptionService.get();
        this.subscriptionWatcher = this.subscriptionService.watch().subscribe(subscription => {
            this.subscription = subscription
        });

        this.user = this.userService.get();
        this.userWatcher = this.userService.watch().subscribe(user => {
            this.user = user
        });
    }

    public ngOnDestroy() {
        if (this.subscriptionWatcher && !this.subscriptionWatcher.closed) this.subscriptionWatcher.unsubscribe();
    }

    public goToBrowseDirectory() {
        let loading = this.loadingCtrl.create();
        loading.present();

        this.api.getAllChapters().finally(() => {
            loading.dismiss();
        }).subscribe(result => {
            this.navCtrl.push(BrowseDirectoryPage, {
                chapters: result.chapters
            });
            if (this.desktop.isDesktop() == true) {
                this.desktop.getRightPane().setRoot(BlankDesktopPage, {
                    advert: result.advert
                }, {
                    animate: true,
                    direction: 'forward'
                });
            }
        }, error => {
            console.log(error);
            if (typeof error.code !== 'undefined' && error.code == 0) {
                let alert = this.alertCtrl.create({
                    title: 'Error',
                    message: 'An error occured while trying to fetch the directory chapters. Please check your internet connection and try again.',
                    buttons: [{
                        text: 'OK'
                    }]
                });

                alert.present();

                return;
            }

            let alert = this.alertCtrl.create({
                title: 'Error',
                message: 'An error occured while trying to fetch the directory chapters',
                buttons: [{
                    text: 'OK'
                }]
            });

            alert.present();
        });
    }

    public goToSearchDirectory() {
        this.navCtrl.push(SearchDirectoryPage);
    }

    public async goToBookmarks() {
        let loading = this.loadingCtrl.create();
        loading.present();

        let bookmarks = await this.bookmarks.getAll();

        this.navCtrl.push(BookmarksPage, {
            bookmarks: bookmarks
        });

        loading.dismiss(0);
    }

    /**
     * goToContactUs() {
    **/
    public async goToContactUs() {
        if (this.desktop.isDesktop()) {
            await this.desktop.getRightPane().setRoot(ContactPage);
        } else {
            await this.navCtrl.push(ContactUsPage)
        }
    }

    public goToMyAccount() {
        if (this.user) this.navCtrl.push(MyAccountPage);
        else this.navCtrl.push(LoginPage);
    }

    public goToSubscriptionPage() {
        if (!this.user) return this.directory.showLoginRequiredAlert('You must be logged in to add a subscription');
        return this.subscriptionService.goToSubscriptionPage(this.navCtrl, SubscriptionsPage);
    }

    public purchaseBook() {
        if (this.desktop.isDesktop()) {
            this.api.getHardCopyPurchaseUrl().subscribe((response: GetHardcopyPurchaseUrlResponse) => {
                this.iab.create(response.hardcopy_purchase_url, '_system');
            }, () => {
                let alert = this.alertCtrl.create({
                    title: 'Error',
                    message: 'An error occurred while accessing this feature. Please try again later.',
                    buttons: [{
                        text: 'OK'
                    }]
                });

                alert.present();
            });
        } else {
            if (!this.user) return this.directory.showLoginRequiredAlert('You must be logged in to purchase a hardcopy');

            let loading = this.loadingCtrl.create();
            loading.present();

            this.api.getHardcopyStatus().finally(() => {
                loading.dismiss();
            }).subscribe(result => {
                if (result.available) {
                    this.navCtrl.push(HardcopyIntroPage);
                } else {
                    let alert = this.alertCtrl.create({
                        title: 'Coming soon!',
                        message: 'Ireland - A Directory 2020 will be available for purchase soon. Please try again later.',
                        buttons: [{
                            text: 'OK'
                        }]
                    });

                    alert.present();
                }
            }, () => {
                let alert = this.alertCtrl.create({
                    title: 'Error',
                    message: 'An error occurred while accessing this feature. Please try again later.',
                    buttons: [{
                        text: 'OK'
                    }]
                });

                alert.present();
            });
        }
    }

    public async ionViewWillLeave() {
        await this.closeDesktopContactUsPageIfOpen();
    }

    private async closeDesktopContactUsPageIfOpen() {
        if (this.desktop.isDesktop() && this.desktop.getRightPane().getActive().instance instanceof ContactPage) {
            await this.desktop.getRightPane().setRoot(BlankDesktopPage);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts